var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Thank you for signing the document. A copy of the signed document has been added to your file and forwarded to your advisor. It is possible to download this document and others from the client portal.")])])
}]

export { render, staticRenderFns }